module.exports = __webpack_public_path__ + "img/icon_portrait@2x.c9a86093.png";